import { HTMLAttributes } from 'react'
import { Box, Typography } from '@mui/material'

export type TapeProps = HTMLAttributes<HTMLDivElement> & {
  text: string
  color?: 'primary' | 'secondary' | 'warning' | 'error' | 'info' | 'success'
  speed?: number
  is_first?: boolean
}

const REPEAT = 8

const Tape = ({ text, color = 'warning', speed = 80, is_first, ...props }: TapeProps) => {
  if (!text) return null

  return (
    <Box
      {...props}
      role="marquee"
      aria-label={text}
      sx={{
        overflow: 'hidden',
        width: '100%',
        bgcolor: `${color}.main`,
        color: `${color}.contrastText`
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          display: 'flex',
          width: 'max-content',
          animation: `tape-scroll ${speed}s linear infinite`,
          '@keyframes tape-scroll': {
            from: { transform: 'translateX(0)' },
            to: { transform: 'translateX(-50%)' }
          },
          '@media (prefers-reduced-motion: reduce)': {
            animation: 'none'
          }
        }}
      >
        {[0, 1].map((group) => (
          <Box key={group} sx={{ display: 'flex', flexShrink: 0 }}>
            {Array.from({ length: REPEAT }).map((_, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  py: 1.5,
                  px: 3,
                  whiteSpace: 'nowrap'
                }}
              >
                <Typography variant="textRegular" component="span" sx={{ fontWeight: 500 }}>
                  {text}
                </Typography>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default Tape
